import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { cn } from '../lib/cn.js';
/** Bosilgandan keyin belgi kamida shuncha aylanadi — bitta to'liq aylana. */
const MIN_SPIN_MS = 600;
/**
 * IKONKALI TUGMA — sahifa sarlavhasidagi ikkilamchi harakat.
 *
 * Nega `Button` ning varianti emas: `Button` `loading` da belgini
 * `Spinner` ga ALMASHTIRADI. Yangilash tugmasida bu noto'g'ri — o'sha
 * belgining o'zi aylanishi kerak, aks holda tugmaning eni sakraydi va
 * odam qaysi tugmani bosganini bir zumga yo'qotadi.
 *
 * Aylanish kamida bir to'liq aylanaga boradi (`MIN_SPIN_MS`): keshdan
 * kelgan javob 50 ms da qaytadi va shu zahoti to'xtagan harakat "hech
 * nima bo'lmadi" bo'lib ko'rinardi.
 */
export const IconButton = ({ icon, label, showLabel = false, busy = false, spin = false, disabled, className, onClick, ...rest }) => {
    const [pulsing, setPulsing] = useState(false);
    const timer = useRef(null);
    useEffect(() => () => {
        if (timer.current !== null)
            clearTimeout(timer.current);
    }, []);
    const spinning = spin && (busy || pulsing);
    return (_jsxs("button", { type: "button", 
        // Yuklanish paytida ikkinchi bosish so'rovni takrorlardi.
        disabled: disabled === true || busy, "aria-busy": busy || undefined, title: label, "aria-label": showLabel ? undefined : label, onClick: (event) => {
            if (spin) {
                if (timer.current !== null)
                    clearTimeout(timer.current);
                setPulsing(true);
                timer.current = setTimeout(() => setPulsing(false), MIN_SPIN_MS);
            }
            onClick?.(event);
        }, className: cn('inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap', 'rounded-[var(--radius-sm)] border border-transparent bg-transparent', 'text-sm font-medium text-primary', 'transition-[background-color,border-color,color,transform]', 'duration-[var(--motion-fast)] ease-[var(--ease-standard)]', 'hover:border-border hover:bg-surface-2', 'active:translate-y-px', 'disabled:cursor-not-allowed disabled:opacity-55 disabled:active:translate-y-0', showLabel
            ? // Sarlavhadagi tanlagich bilan bir chiziqda: ikkalasi ham 40px.
                'h-[var(--size-control-md)] px-3.5'
            : // Matnsiz variant — kvadrat 36×36.
                'size-[var(--size-control-sm)]', className), ...rest, children: [_jsx("span", { "aria-hidden": true, className: cn('inline-flex items-center', spinning ? 'motion-spin' : undefined), children: icon }), showLabel ? label : null] }));
};
//# sourceMappingURL=IconButton.js.map